import './style.scss';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { PasskeySuggestionProps } from './hooks';
import { useState } from 'react';
import { Guidances } from 'views/components/atoms/guidances';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';

export const PasskeySuggestionModal = (props: PasskeySuggestionProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const { onCompleted } = props;
  return (
    <ModalBase
      modalStyle={ModalStyle.confirmModal}
      isOpen={isOpen}
      children={
        <div className="passkeySuggestionModal">
          <Guidances label={<div>パスキーの設定</div>} isRowGapMin={true} />
          <div className="passkeySuggestion_text">
            <span>
              「パスキー認証」とは、生体認証等（顔認証、指紋認証、PINコード、パターン認証）により本人確認を行う認証方式です。
            </span>
            <span>パスキー認証を用いてログインする場合には、パスワードの入力は不要になります。</span>
          </div>
          <div className="passkeySuggestion_button">
            <Button
              label="後で"
              fillType={FillType.primaryEmpty}
              buttonSize={ButtonSize.sizeS}
              disabled={isProcessing}
              onClick={async () => {
                setIsProcessing(true);
                await onCompleted?.();
                setIsOpen(false);
              }}
            />
            <Button
              label="パスキー設定へ"
              fillType={FillType.primaryFill}
              buttonSize={ButtonSize.sizeS}
              disabled={isProcessing}
              onClick={async () => {
                setIsProcessing(true);
                await onCompleted?.();
                setIsOpen(false);
                const url = `${process.env.REACT_APP_SCHEME_FOR_MFA}/securitySetting?tab=1`;
                window.location.assign(url);
              }}
            />
          </div>
        </div>
      }
      shouldCloseOnOverlayClick={false}
    />
  );
};
